export default __webpack_public_path__ + "static/media/project-01.12e38532.png";